<article class="list-page-layout">
	<ng-content select="[listHeader]" />
	<ng-content select="[listFilters]" />
	<ng-content select="[listBody]" />
	<ng-content select="[listFooter]" />
</article>
